module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/2fa/two-fa-control/two-fa-control.component.scss
// module id = ./web/modern/components/2fa/two-fa-control/two-fa-control.component.scss
// module chunks = 0